<p-tabView [(activeIndex)]="activeIndex">
  <p-tabPanel class="mb-2" [disabled]="disabledInputs" header="Inputs used in calculation ">
    <app-eea-output-project-macro-gw-run-inputs *ngIf="!disabledInputs"
     [selectedModel]="selectedModel" [selectedProject]="selectedProject"></app-eea-output-project-macro-gw-run-inputs>
  </p-tabPanel>
  <p-tabPanel class="mb-2" [disabled]="disabledSummary" header="Summary of the results">
    <eea-output-project-macrogw-result-summary *ngIf="!disabledSummary"
      [selectedProject]="selectedProject" [selectedModel]="selectedModel"></eea-output-project-macrogw-result-summary>
  </p-tabPanel>
</p-tabView>